import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { HERO_IMAGE } from '../../data/content';
const stats = ['6 VOLUMES', '60+ DECISION CARDS', '30 CASES', '5 BONUSES'];
const assurances = ['Instant Digital Access', 'One-Time Payment of $27', 'Lifetime Access', '7-Day Guarantee'];
export function Hero() {
  return <section className="w-full bg-navy-950 px-4 pb-14 pt-10 sm:px-6 sm:pb-20 sm:pt-14" data-id="element-187" data-mp="mry068nlu2qy">
      <div className="mx-auto w-full max-w-3xl text-center" data-id="element-188" data-mp="qtszx8pw082m">
        <p className="mb-4 inline-block rounded-full border border-sky-400/40 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-sky-300 sm:text-xs" data-id="element-189" data-mp="vm2lydnvsnzm">
          The Visual TRT Decision System
        </p>

        <h1 className="font-display text-[34px] leading-[1.05] text-white sm:text-6xl" data-id="element-190" data-mp="15lte48oyyqwj">
          TRT DECISION
          <br data-id="element-191" data-mp="1ak4t0xu4frlm" />
          <span className="text-sky-400" data-id="element-192" data-mp="1ahiluzb57e3x">DECK™</span>
        </h1>

        <p className="mx-auto mt-4 max-w-xl font-display text-lg uppercase leading-snug text-gold-400 sm:text-2xl" data-id="element-193" data-mp="9olzadweu6ph">
          Organize a TRT consultation in 5 minutes or less
        </p>

        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-sky-100/75 sm:text-base" data-id="element-194" data-mp="3vw2cuusicuqd">
          A practical digital decision-deck system with 60+ clinical decision cards, organized into
          6 volumes, designed to help you quickly identify the scenario in front of you, organize
          the information you need to review, and follow a structured clinical pathway.
        </p>

        <img src={HERO_IMAGE} alt="The TRT Decision Deck box set with its six volumes and clinical decision cards" className="mx-auto mt-7 w-full max-w-lg" data-id="element-195" data-mp="infq1nn282v4" />

        <ul className="mt-6 grid grid-cols-2 gap-2" data-id="element-196" data-mp="1b51yiu5e6ncd">
          {stats.map(stat => <li key={stat} className="rounded-lg border border-sky-400/20 bg-navy-800 px-2 py-3 font-display text-xs uppercase leading-tight tracking-wide text-sky-200 sm:text-sm" data-id="element-197" data-mp="16djx64zgikqv">
              {stat}
            </li>)}
        </ul>

        <div className="mt-7" data-id="element-198" data-mp="2qwdt6zvqw8zq">
          <CTAButton id="primary-cta" label="Get the TRT Decision Deck™" data-id="element-199" data-mp="2qv2omxuh6x7k" />
        </div>

        <ul className="mt-5 grid gap-2 text-left sm:grid-cols-2" data-id="element-200" data-mp="2vufgjx07euh0">
          {assurances.map(item => <li key={item} className="flex items-center gap-2 text-sm text-sky-100/80" data-id="element-201" data-mp="2hueam3530wuo">
              <CheckIcon className="h-4 w-4 shrink-0 text-emerald-400" aria-hidden="true" data-id="element-202" data-mp="2musklqq8ugvc" />
              {item}
            </li>)}
        </ul>

        <div className="mt-8" data-id="element-203" data-mp="27zmfd5yz2m32">
          <Countdown data-id="element-204" data-mp="2cvtd4bh7sr9x" />
        </div>

        <div className="mt-5" data-id="element-205" data-mp="2cwuz3azrqy6f">
          <ScarcityBar data-id="element-206" data-mp="2cy6238le41wh" />
        </div>

        <p className="mt-4 text-xs text-sky-100/50" data-id="element-207" data-mp="65n6ssd8iiu2">
          The currency will be automatically converted according to your country.
        </p>
      </div>
    </section>;
}